/**
 * @Author: v_jppjpeng
 * @Date: 2023-07-28 10:53:38
 * @Explain: 链接按钮
 */
import { Icon, Tooltip } from '@/components/tdesign';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useMemo } from 'react';
import type { ButtonProps } from 'tdesign-react';
import { Button as TButton } from 'tdesign-react';
import type { ButtonPropsType } from '../data.d';

function Button(props: ButtonPropsType) {
  const {
    className,
    children,
    disabled,
    loading,
    type,
    useType = 'main',
    theme = 'default',
    variant = 'base',
    shape = 'round',
    size = 'xl',
    prefixIcon,
    prefixIconName,
    suffixIcon,
    suffixIconName,
    tooltip,
    tooltipPlacement,
    tooltipOffset,
    style,
    buttonProps,
    tipProps,
    onClick,
    overlayInnerClassName,
  } = props;

  const iconRender = (iconName?: string, iconEl?: ReactNode) => {
    if (iconName) {
      return <Icon.Font name={iconName} />;
    }
    if (iconEl) {
      return iconEl;
    }
    return undefined;
  };

  const customProps: ButtonProps = useMemo(
    () => ({
      className: classNames(
        'default-td-button',
        {
          [`size-${size}`]: size,
          [`use-${useType}`]: useType,
        },
        className,
      ),
      style,
      disabled,
      loading,
      type,
      theme,
      variant,
      shape,
      icon:
        (prefixIcon || prefixIconName) && !loading ? (
          <div className="t-button__prefix">
            {iconRender(prefixIconName, prefixIcon)}
          </div>
        ) : undefined,
      suffix:
        (suffixIcon || suffixIconName) && !loading
          ? iconRender(suffixIconName, suffixIcon)
          : undefined,
      onClick,
    }),
    [
      className,
      style,
      disabled,
      loading,
      type,
      theme,
      variant,
      shape,
      size,
      prefixIcon,
      prefixIconName,
      suffixIcon,
      suffixIconName,
      onClick,
    ],
  );

  // const contentRender = useMemo(() => {
  //   return (
  //     <>
  //       {(prefixIcon || prefixIconName) && (
  //         <div className="prefix-icon">
  //           {iconRender(prefixIconName, prefixIcon)}
  //         </div>
  //       )}
  //       {children}
  //       {(suffixIcon || suffixIconName) && (
  //         <div className="suffix-icon">
  //           {iconRender(suffixIconName, suffixIcon)}
  //         </div>
  //       )}
  //     </>
  //   );
  // }, [children, prefixIcon, suffixIcon]);

  return tooltip ? (
    <Tooltip
      content={tooltip}
      placement={tooltipPlacement}
      placementOffset={tooltipOffset}
      tooltipProps={tipProps}
      overlayInnerClassName={overlayInnerClassName}
    >
      <TButton {...customProps} {...buttonProps}>
        {children}
      </TButton>
    </Tooltip>
  ) : (
    <TButton {...customProps} {...buttonProps}>
      {children}
    </TButton>
  );
}

export default Button;
